import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function Profile() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [user, setUser] = React.useState(false);

    let refEmail = React.useRef();
    let refContact = React.useRef();
    let refPhone = React.useRef();

    React.useEffect(() => {
        fetch(Config.url.API_URL +'/api/user/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: userId
            })
        }).then(response => {
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            refEmail.current.value = result.email;
            refContact.current.value = result.contact;
            refPhone.current.value = result.phone;
            setUser(result);
        }).catch(err => {
            toast.error(err.message);
        });
    }, []);

    const onUpdate = () => {
        let email = refEmail.current.value;
        let contact = refContact.current.value;
        let phone = refPhone.current.value;
        if(!email || !Utils.validateEmail.test(email)) {
            toast.error("กรุณาระบุ Email ให้ถูกต้อง\n* เช่น your@email.com");
        }
        else if(!contact) {
            toast.error("กรุณาระบุ ชื่อผู้ติดต่อ");
            refContact.current.focus();
        }
        else if(!phone) {
            toast.error("กรุณาระบุ เบอร์ติดต่อ");
            refPhone.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);
                            const body = {
                                id: user.id,
                                contact: contact,
                                phone: phone,
                                email: email,
                                currentEmail: user.email,
                                updatedBy: user.id,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/user/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย", {autoClose: 2000});
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    let [validEmail, setValidEmail] = React.useState(true);
    const onKeyUpEmail = (e) => {
        if(e.target.value) {
            let valid = Utils.validateEmail.test(e.target.value);
            setValidEmail(valid);
        }
        else {
            setValidEmail(true);
        }
        user.email = e.target.value;
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Users Management</div>
                    <span className="ms-1">/</span> <span className="text-muted">Profile</span>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="email" ref={refEmail} maxLength={100} onKeyUp={e => onKeyUpEmail(e)} />
                                <p className={!validEmail ? 'text-danger mb-0 small':'d-none'}>รูปแบบอีเมลไม่ถูกต้อง</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="contact" className="form-label">ชื่อผู้ติดต่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="contact" ref={refContact} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="phone" className="form-label">เบอร์ติดต่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="phone" ref={refPhone} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 